// Client's real editorial photography (Texas Journal shoot) — served from /public/photos
export const HERO_IMG = "/photos/tj-01.jpg";

export const GALLERY = [
  { src: "/photos/tj-03.jpg", title: "Sunlit Denim", issue: "Style in Austin", span: "tall" },
  { src: "/photos/tj-06.jpg", title: "Easy Flares", issue: "The Debut Issue", span: "wide" },
  { src: "/photos/tj-09.jpg", title: "Sidewalk Muse", issue: "Style in Austin", span: "normal" },
  { src: "/photos/tj-08.jpg", title: "Sunflower", issue: "Art of Fashion", span: "tall" },
  { src: "/photos/tj-04.jpg", title: "In Profile", issue: "Art of Fashion", span: "normal" },
  { src: "/photos/tj-02.jpg", title: "Backyard Editorial", issue: "The Debut Issue", span: "wide" },
];

export const AD_IMG = "/photos/tj-05.jpg";
export const AD_IMG_2 = "/photos/tj-07.jpg";
